import { Dialog, useDialogRoute } from "@dash/dialog";
import { Button } from "@dash/form";
import { useDeviceType } from "@dash/mq";
import { MdOutlineDownload } from "react-icons/md";

import { CalendarButton } from "./CalendarButton";
import { MilageReportDialog } from "./millageReport/MilageReportDialog";
import { WorkTimeReportDialog } from "./workTime/WorkTimeDialog";

export const ActionButtons = () => {
  const { isMobile } = useDeviceType();

  const milageReportDialog = useDialogRoute("/kilometry", ({ onClose }) => (
    <Dialog onClose={onClose} header="Przejechane kilometry" placement={isMobile ? "top" : "center"}>
      <MilageReportDialog />
    </Dialog>
  ));

  const workTimeReportDialog = useDialogRoute("/czas-pracy", ({ onClose }) => (
    <Dialog onClose={onClose} header="Czas pracy" placement={isMobile ? "top" : "center"}>
      <WorkTimeReportDialog />
    </Dialog>
  ));

  return (
    <>
      <div css={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        <Button icon={<MdOutlineDownload />} variant="outline" onClick={workTimeReportDialog.open} size="small">
          Czas pracy
        </Button>
        <Button icon={<MdOutlineDownload />} variant="outline" onClick={milageReportDialog.open} size="small">
          Kilometry
        </Button>
        <CalendarButton />
      </div>
      {milageReportDialog.element}
      {workTimeReportDialog.element}
    </>
  );
};
